import { render, staticRenderFns } from "./academic_wordgroup_management.vue?vue&type=template&id=9355fd42&scoped=true&"
import script from "./academic_wordgroup_management.vue?vue&type=script&lang=js&"
export * from "./academic_wordgroup_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_wordgroup_management.vue?vue&type=style&index=0&id=9355fd42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9355fd42",
  null
  
)

export default component.exports